// extracted by mini-css-extract-plugin
export default {"summary":"Summary_summary__yyDHU","point":"Summary_point__qvTra","score":"Summary_score__fc2Fy","badge":"Summary_badge__tLxiE"};